import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./PlayerScore.module.css";

function PlayerScore({ image, imageAlt, score, playerNameText, customStyles }) {
  const [t, i18n] = useTranslation("common");

  return (
    <div className={cn(styles.wrapper, customStyles.wrapperStyles)}>
      <img src={image} alt={imageAlt} />
      <p className={cn(styles.scoreValue, customStyles.scoreValue)}>{score}</p>
      <p className={cn(styles.playerNameText, customStyles.playerNameText)}>
        {playerNameText}
      </p>
    </div>
  );
}

export default React.memo(PlayerScore);
